import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const HeaderWrap = styled.header`
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 4;
`;

export const HeaderFixed = styled.div`
  position: relative;
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  box-shadow: var(--shadow-base);
`;

export const HeaderInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: var(--content-max-width);
  margin: 0 auto;
  padding: 16px 40px;
  box-sizing: border-box;
`;

export const LogoLink = styled(Link)`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-right: 24px;
  line-height: 0;
  width: 148px;

  svg {
    display: block;
    width: 148px;
    height: 23px;
  }

  &,
  &:hover,
  &:focus,
  &:active,
  &:visited {
    outline: none;
    text-decoration: none;
  }
`;

export const LogoutWrapper = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`;

export const AuthEntryButton = styled.button`
  padding: 10px 12px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  line-height: 22px;
  font-weight: bold;
  text-transform: uppercase;
  color: var(--black-40);

  &:hover,
  &:focus,
  &:active {
    outline: none;
    color: var(--black-40);
  }
`;
